// @flow
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Typography } from "@material-ui/core";
import { fetchGroupLicences } from "../../actions/licenceActions";
import type { StateType, DispatchType } from "../../../global/types/redux";
import LicenceList from "../../components/licences/LicenceList";
import LicenceItemRedux from "./LicenceItemRedux";
import { buildLicenceItemJson } from "../../components/companies/CompileCompanytoJson";
import { LoadingProgress, NoItem, AppHeader } from "imagus-components";
import type {
  ChildrenNodeType,
  LicenceCompany
} from "../../types/licenceTypes";
import { LicencePageLayout } from "../../components/licences/LicencePageLayout";
import { ThreeSixty } from "@material-ui/icons";
import { LicenceCompanyList } from "../../components/licences/licenceCompany/LicenceCompanyList";
import { hasPrincipal } from "../../../global/containers/UserAuth";

const CompanyLevels = {
  EndUser: 1,
  Reseller: 2,
  Distributer: 3,
  TopLevel: 4
};
class MyLicence extends Component<*> {
  componentDidMount() {
    this.props.company &&
      this.props.actions.fetchGroupLicences(this.props.company.companyType);
  }

  componentDidUpdate(prevProps) {
    if (this.props.company) {
      if (prevProps.company !== this.props.company) {
        this.props.actions.fetchGroupLicences(this.props.company.companyType);
      }
    }
  }

  render(): * {
    const groupLicences = this.props.licence && this.props.licence.children;
    const myLicences =
      this.props.user.licences && this.props.user.licences.edges;

    const Children = this.props.licence.children && (
      <>
        {!groupLicences ? (
          <LoadingProgress />
        ) : (
          <>
            {groupLicences.edges.length > 0 && (
              <>
                <Typography variant="h6">
                  {groupLicences.edges[0].node.companyType}
                </Typography>
                <LicenceCompanyList
                  companies={this.props.licence.children.edges}
                />
              </>
            )}
          </>
        )}
      </>
    );

    if (!myLicences) {
      return <LoadingProgress />;
    } else {
      return (
        <Fragment>
          <AppHeader title="My Licences" />
          <div className="app-panel">
            <LicencePageLayout licences={myLicences} />
            {hasPrincipal("company_children_read", this.props.user.groups) &&
              Children}
          </div>
        </Fragment>
      );
    }
  }
}

const mapStateToProps = (state: StateType): * => ({
  licence: state.v3account.licence,
  user: state.v3account.user,
  company: state.v3account.user.company
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    {
      fetchGroupLicences
    },
    dispatch
  )
});
export default connect(mapStateToProps, mapDispatchToProps)(MyLicence);
